import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import { from } from 'rxjs'
import api from '../../../api';
import { handleJoinNow } from '../../../common/utils/utils';

const JoinEventAction = ({ payload: { eventId }, onComplete }) => {
    const user = useSelector(getUser);
    
    useEffect(() => {
        const subscription = from(api.get(`${process.env.REACT_APP_API_URL}/events/${eventId}`)).subscribe({
            next: ({ data: event }) => {
                if (event) {
                    handleJoinNow(null, user, () => console.debug('Join event success'), event);
                }
                onComplete(event);
            },
            error: (err) => {
                console.error(`Error fetching event ${eventId}: ${err.message}`);
                onComplete(null);
            },
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line
    }, [eventId]);
};

export default JoinEventAction;
